<template>
  <el-container>
    <el-card shadow="never" style="width: 100%;" :body-style="{padding:0,border:0}">
      <template slot="header">
        <div style="clear: both;height:40px;">
          学生列表
          <div style="float: right;">
            <el-button type="primary" @click="dialogUpload=true">Excel上传</el-button>
            <el-button type="success" @click="downExcel">样例下载</el-button>
          </div>
        </div>

        <div class="line"></div>
        <user-detail-search></user-detail-search>
      </template>
      <el-table
              style="border-top:0;border-bottom: 0;"
              :border="true"
              :data="user_detailList"
              :stripe="true"
              size="medium"
              v-loading="loading"
              element-loading-text="玩命加载中..."
              @selection-change="selectColChange"
      >
        <el-table-column
                type="selection"
                width="55">
        </el-table-column>
        <el-table-column prop="name"
                         label="姓名"></el-table-column>
        <el-table-column prop="schoole_name"
                         label="学校名称"></el-table-column>
        <el-table-column prop="magor"
                         label="专业名称"></el-table-column>
        <el-table-column prop="gradation"
                         label="层次"></el-table-column>
        <el-table-column prop="card_id"
                         label="证书编号"></el-table-column>
        <el-table-column prop="card_number"
                         label="身份证号"></el-table-column>
        <!--<el-table-column prop="school_roll"-->
        <!--label="学籍"></el-table-column>-->
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="show(scope.row)">编辑</el-button>
            <el-button size="mini" type="text" @click="destory(scope.row)"><span style="color: #F00">删除</span>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin: 20px 0 20px 20px">
        <el-button type="danger" size="small" @click="removeSelectIds">选中删除</el-button>

        <el-pagination
                style="float: right"
                @current-change="setpage"
                layout="prev, pager, next"
                :current-page="page.currentPage"
                :page-size="page.pageSize"
                :total="page.total">
        </el-pagination>
      </div>


    </el-card>


    <el-dialog
            title="提示"
            :visible.sync="dialogUpload"
            :before-close="handleDialogClose"
            width="50%">
      <!--<el-dialog-->
      <!--width="50%"-->
      <!--title="请勿刷新页面"-->
      <!--:visible.sync="upoloadProgressDialog"-->
      <!--append-to-body>-->
      <!--<el-progress :text-inside="true" :stroke-width="18" :percentage="uploadProgress"></el-progress>-->
      <!--</el-dialog>-->
      <el-form label-position="left" label-width="180px">
        <el-form-item label="excel文件">
          <el-upload
                  class="upload-demo"
                  ref="upload"
                  :action="uploadPath"
                  :before-upload="beforeUpload"
                  :on-progress="getProgress"
                  :on-success="uploadSuccess"
                  :file-list="fileList"
                  :limit="1"
                  name="upload"
                  :auto-upload="false">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <div slot="tip" class="el-upload__tip">请上传指定格式的Excel</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogUpload = false">取 消</el-button>
          <el-button type="primary" @click="readExcel">确 定</el-button>
        </span>
    </el-dialog>

    <el-dialog title="读取Excel" :visible.sync="readExcelDialog" :fullscreen="true" @open="buttonText='开始导入'">
      <el-table :data="excelData">
        <el-table-column property="error_message" label="错误信息" width="200">
          <template slot-scope="scope">
            {{scope.row.error_message}}
          </template>
        </el-table-column>

        <el-table-column property="name" label="姓名" width="200"></el-table-column>
        <!--<el-table-column property="phone" label="手机号"></el-table-column>-->
        <el-table-column property="sex" label="性别"></el-table-column>
        <el-table-column property="birthday" label="生日"></el-table-column>
        <el-table-column property="school_start" label="入校时间"></el-table-column>
        <el-table-column property="school_end" label="毕业时间"></el-table-column>
        <el-table-column property="schoole_name" label="学校名称"></el-table-column>
        <el-table-column property="magor" label="专业名称"></el-table-column>
        <el-table-column property="magor_type" label="专业类型"></el-table-column>
        <!--<el-table-column property="school_roll" label="学籍"></el-table-column>-->
        <el-table-column property="study_func" label="学习形式"></el-table-column>
        <el-table-column property="gradation" label="层次"></el-table-column>
        <el-table-column property="status" label="状态"></el-table-column>
        <el-table-column property="dean_name" label="校(院)长姓名"></el-table-column>
        <el-table-column property="card_id" label="证书编号"></el-table-column>
        <el-table-column property="card_number" label="身份证号"></el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeReadExcelDiaLog">关 闭</el-button>
        <el-button type="primary" @click="createDataArray">{{buttonText}}</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
  import {mapState, mapActions} from 'vuex'
  import XLSX from 'xlsx';
  import UserDetailSearch from "./UserDetailSearch";
  import arrayUtil from 'array-tools'
  import config from '@/lib/http/config'
  import http from '@/lib/admin/http'

  export default {
    name: "UserDetail",
    components: {UserDetailSearch},
    created() {
      this.$store.dispatch('user_detail/getList');
      let vthis = this;
    },
    computed: {
      ...mapState({
        user_detailList: state => state.user_detail.list,
        page: state => state.user_detail.page,
        loading: state => state.user_detail.loading
      }),
      uploadPath() {
        return "";
      }
    },
    data() {
      return {
        upoloadProgressDialog: false,
        dialogUpload: false,
        fileList: [],
        readExcelDialog: false,
        excelData: [],
        buttonText: "开始导入",
        selectIds: [],
      }
    },
    methods: {
      ...mapActions({
        destory: 'user_detail/destory',
        getList: 'user_detail/getList'
      }),
      downExcel() {
        window.location.href="http://www.cxedu.org.cn/%E5%AF%BC%E5%85%A5%E8%A1%A8%E6%A0%BC%E6%A0%B7%E5%BC%8F.xlsx";
      },
      /**
       * 将选中的id 放到data里
       */
      selectColChange(rows) {
        let ids = [];
        rows.map(row => {
          ids.push(row.id);
        });
        this.selectIds = ids;
      },

      /**
       * removeSelectIds
       * 请求删除操作
       */
      async removeSelectIds() {
        this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          http.postData('/api/admin/userDetailRemoveIds', {ids: this.selectIds}).then(res => {
            if (res.result.code == 1) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.$store.dispatch('user_detail/getList');

            } else {
              this.$message({
                type: 'error',
                message: res.result.message
              });
            }
          });

        }).catch(async () => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });


        });
      },

      /**
       * 关闭excel框
       */
      closeReadExcelDiaLog() {
        this.readExcelDialog = false;
        this.$refs.upload.clearFiles();
      },
      createDataArray() {
        let vthis = this;
        let count = this.excelData.length;
        this.excelData.map(async (item, index) => {
          let res = await vthis.createData(item, index);
          if (index == count - 1) {
            vthis.getList();
            vthis.buttonText = "重试"
          }

        });
      },
      createData(data, index) {
        let vthis = this;
        return new Promise(async (success, faild) => {
          let createData = Object.assign({}, data);
          vthis.$store.commit('user_detail/setCreate', createData);
          let response = await vthis.$store.dispatch('user_detail/create');

          if (response.result.code != 1) {
            vthis.$notify.error({
              title: '错误',
              dangerouslyUseHTMLString: true,
              duration: 0,
              message: response.result.message,
            });
            data.has_error = 1;
            data.error_message = response.result.message;
          } else {
            data.has_error = 0;
            data.error_message = '添加成功';
          }
          vthis.excelData.splice(index, 1, data);
          vthis.dialogUpload = false;
          vthis.readExcelDialog = false;
          vthis.$message({
            message: '导入成功',
            type: 'success'
          });
          success();
        })

      },

      setpage(pageNow) {
        let page = this.page;
        page.currentPage = pageNow;
        this.$store.dispatch('user_detail/getList', page)
      },
      show(row) {
        this.$router.push({
          name: 'UserDetailEdit',
          params: {
            id: row.id
          }
        })
      },

      handleDialogClose(){
        this.dialogUpload = false;
      },
      uploadSuccess(response, file, fileList) {

      },
      readExcel() {
        this.dialogUpload = false;
        this.$refs.upload.submit();
      },
      beforeUpload(file) {
        // this.upoloadProgressDialog = true;
        this.importExcel(file);
        this.readExcelDialog = true;
        return false;
      },
      getProgress(event, file, fileList) {
        // console.log(event, file, fileList);
        // this.uploadProgress = event.percent;
      },


      /**
       * 读取 excel 文件
       */
      importExcel(file) {
        let vthis = this;
        var fileReader = new FileReader();
        fileReader.onload = function (ev) {
          try {
            var data = ev.target.result,
                    workbook = XLSX.read(data, {
                      type: 'binary'
                    }), // 以二进制流方式读取得到整份excel表格对象
                    persons = []; // 存储获取到的数据
          } catch (e) {
            this.$notify.error({
              title: '错误',
              message: '文件类型不正确'
            });

            return;
          }

          // 表格的表格范围，可用于判断表头是否数量是否正确
          var fromTo = '';
          // 遍历每张表读取
          for (var sheet in workbook.Sheets) {
            if (workbook.Sheets.hasOwnProperty(sheet)) {
              fromTo = workbook.Sheets[sheet]['!ref'];
              console.log(fromTo);
              persons = persons.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]));
              break; // 如果只取第一张表，就取消注释这行
            }
          }

          let list = [];
          let exists = [];

          persons.map(item => {
            let user = {};
            user.name = item['姓名'];
            user.sex = item['性别'];
            user.birthday = vthis.formatDate(item['生日']);
            user.school_start = vthis.formatDate(item['入校时间']);
            user.school_end = vthis.formatDate(item['毕业时间']);
            user.schoole_name = item['学校名称'];
            user.magor = item['专业名称'];
            user.magor_type = item['专业类型'];
            user.study_func = item['学习形式'];
            user.gradation = item['层次'];
            user.status = item['状态'];
            user.dean_name = item['校（院）长姓名'];
            user.card_id = item['证书编号'];
            user.card_number = item['身份证号'];
            user.has_error = 0;
            user.error_message = "";

            //
            if (!arrayUtil.exists(list, {card_number: user.card_number})) {
              list.push(user);
            } else {
              exists.push(user)
            }
          });

          vthis.excelData = list;

          if (exists.length > 0) {
            let str = "";
            exists.map(item => {
              str += "\n<br>";
              str += "姓名： " + item.name;
            });

            vthis.$notify.warning({
              title: '警告, 这些用户身份证信息重复导入，已自动过滤，请确认无误后再开始录入',
              dangerouslyUseHTMLString: true,
              duration: 0,
              message: str,
            });
          }

        };

        // 以二进制方式打开文件
        fileReader.readAsBinaryString(file);
      },
      formatDate(numb, format) {
        let time = new Date((numb - 1) * 24 * 3600000 + 1)
        time.setYear(time.getFullYear() - 70)
        let year = time.getFullYear() + ''
        let month = time.getMonth() + 1 + ''
        let date = time.getDate() + ''
        if (format && format.length === 1) {
          return year + format + month + format + date
        }
        return year + "-" + (month < 10 ? '0' + month : month) + "-" + (date < 10 ? '0' + date : date)
      },


      /**
       * 开始导入， 请求接口
       */
      startImport() {
        console.log(this.excelData);

        function updateData(data) {
          return http.postData('/api/admin/batch_users', data);
        }

        this.excelData.map(async item => {
          await updateData(item).then(res => {
            if (res.result.code != 1) {
              item.status = res.result.message;
            } else {
              item.status = "已导入";
            }
          })
        });
      }
      ,
    }
  }
</script>

<style scoped>
  .line {
    border: 0.5px solid #ebeef5;
    margin: 15px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/user_detail/UserDetail.vue